import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { Button, Label, LABEL_TYPE } from '@/components/generic';
import { Error403, Error404, Error500 } from '@/resources';
import { TestIds } from '@/shared/test-ids';

export const ERROR_TYPE = {
  NOT_FOUND: 404,
  FORBIDDEN: 403,
  INTERNAL_ERROR: 500
};

type ErrorPageProps = {
  code: number;
};

export const ErrorPage = ({ code }: ErrorPageProps) => {
  const [t] = useTranslation('common');
  const navigate = useNavigate();

  const error =
    code === ERROR_TYPE.FORBIDDEN
      ? {
          icon: <Error403 className='h-80 w-full' />,
          text: 'forbiddenAccess'
        }
      : code === ERROR_TYPE.NOT_FOUND
        ? {
            icon: <Error404 className='h-80 w-full' />,
            text: 'notFound'
          }
        : {
            icon: <Error500 className='h-80 w-full' />,
            text: 'somethingWentWrong'
          };

  return (
    <div
      className='flex h-screen w-full flex-col items-center justify-center gap-6 pt-4'
      data-testid={TestIds.errorPage.root}
      data-error-code={String(code)}>
      <div className='flex flex-col items-center justify-center gap-4'>
        <Label text={t('oops')} type={LABEL_TYPE.H1} className='text-secondary-steel-blue' />
        <Label text={t(error.text)} type={LABEL_TYPE.PARAGRAPH1_BOLD} />
      </div>
      <Button handleOnClick={() => navigate(-1)} data-testid={TestIds.errorPage.goBack}>
        {t('goBack')}
      </Button>
      {error.icon}
    </div>
  );
};
